var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [
          _c(
            "b-form-group",
            [
              _c(
                "b-form-checkbox",
                {
                  staticClass: "mb-2",
                  attrs: {
                    id: "declaraciones-veracidad-f1",
                    name: "declaracionVeracidad",
                    disabled: _vm.readOnly,
                    switch: "",
                  },
                  model: {
                    value: _vm.declaraciones.declaracionVeracidad,
                    callback: function ($$v) {
                      _vm.$set(_vm.declaraciones, "declaracionVeracidad", $$v)
                    },
                    expression: "declaraciones.declaracionVeracidad",
                  },
                },
                [
                  _c("b", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("apeironGwApp.programa.declaraciones.veracidad")
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.$v.declaraciones.declaracionVeracidad?.sameAsTrue
            ? _c("small", { staticClass: "text-danger" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("apeironGwApp.programa.declaraciones.debeAceptar")
                  )
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-form-group",
            [
              _c(
                "b-form-checkbox",
                {
                  staticClass: "mb-2",
                  attrs: {
                    id: "declaraciones-compromiso-actualizacion-f1",
                    name: "compromisoActualizacion",
                    disabled: _vm.readOnly,
                    switch: "",
                  },
                  model: {
                    value: _vm.declaraciones.compromisoActualizacion,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.declaraciones,
                        "compromisoActualizacion",
                        $$v
                      )
                    },
                    expression: "declaraciones.compromisoActualizacion",
                  },
                },
                [
                  _c("b", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.programa.declaraciones.compromisoActualización"
                        )
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.$v.declaraciones.compromisoActualizacion?.sameAsTrue
            ? _c("small", { staticClass: "text-danger" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("apeironGwApp.programa.declaraciones.debeAceptar")
                  )
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-form-group",
            [
              _c(
                "b-form-checkbox",
                {
                  staticClass: "mb-2",
                  attrs: {
                    id: "aceptacionPrivacidad-f1",
                    name: "aceptacionPrivacidad",
                    disabled: _vm.readOnly,
                    switch: "",
                  },
                  model: {
                    value: _vm.declaraciones.aceptacionPrivacidad,
                    callback: function ($$v) {
                      _vm.$set(_vm.declaraciones, "aceptacionPrivacidad", $$v)
                    },
                    expression: "declaraciones.aceptacionPrivacidad",
                  },
                },
                [
                  _c("b", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.programa.declaraciones.politicaPrivacidad"
                        )
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.$v.declaraciones.aceptacionPrivacidad?.sameAsTrue
            ? _c("small", { staticClass: "text-danger" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("apeironGwApp.programa.declaraciones.debeAceptar")
                  )
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-form-group",
            [
              _c(
                "b-form-checkbox",
                {
                  staticClass: "mb-2",
                  attrs: {
                    id: "declaraciones-aceptacion-lineamientos-f1",
                    name: "aceptacionLineamientos",
                    disabled: _vm.readOnly,
                    switch: "",
                  },
                  model: {
                    value: _vm.declaraciones.aceptacionLineamientos,
                    callback: function ($$v) {
                      _vm.$set(_vm.declaraciones, "aceptacionLineamientos", $$v)
                    },
                    expression: "declaraciones.aceptacionLineamientos",
                  },
                },
                [
                  _c("b", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.programa.declaraciones.aceptacionLineamientos"
                        )
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.$v.declaraciones.aceptacionLineamientos?.sameAsTrue
            ? _c("small", { staticClass: "text-danger" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("apeironGwApp.programa.declaraciones.debeAceptar")
                  )
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card-text",
        { staticStyle: { "text-align": "end" } },
        [
          !_vm.readOnly
            ? _c(
                "b-button",
                {
                  attrs: { variant: "primary", disabled: _vm.$v.$invalid },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.$t("entity.action.save")),
                    },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "save" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }